// 系统管理
import personCenter from '../../views/personCenter/index'; // 个人中心
export default [
    {
        path: '/personCenter',
        name: 'personCenter',
        meta: { title: '个人中心' },
        component: personCenter // 机构管理
    }
];
